/* eslint-disable camelcase */
import { LoggerFactory, DOMAIN, FEATURE } from 'Services/Logger';

const logger = LoggerFactory.getLogger(DOMAIN.MOBILE);

export const EVENTS = {
  flutterInAppWebViewPlatformReady: 'flutterInAppWebViewPlatformReady',
  handleSessionExpired: 'handleSessionExpired',
  handleSessionSaved: 'handleSessionSaved',
  saveSession: 'saveSession',
} as const;

export const isFlutterInAppWebEnabled = () => Boolean(window?.flutter_inappwebview);

export const sendHandleSessionExpiredEvent = async () => {
  if (!isFlutterInAppWebEnabled()) return;

  const { handleSessionExpired } = EVENTS;
  const debugValues = {
    isFlutterInAppWebEnabled: isFlutterInAppWebEnabled(),
  };
  logger.info(
    `FlutterInAppWebView Sending ${handleSessionExpired} event`,
    `${DOMAIN.MOBILE}.${FEATURE.LOGIN}`,
    debugValues,
  );
  await window?.flutter_inappwebview?.callHandler?.(handleSessionExpired);
  logger.info(
    `FlutterInAppWebView Event ${handleSessionExpired} sent`,
    `${DOMAIN.MOBILE}.${FEATURE.LOGIN}`,
    debugValues,
  );
};

export const sendHandleSaveSession = async () => {
  if (!isFlutterInAppWebEnabled()) return;

  const { saveSession } = EVENTS;
  const debugValues = {
    isFlutterInAppWebEnabled: isFlutterInAppWebEnabled(),
  };
  logger.info(
    `FlutterInAppWebView Sending ${saveSession} event`,
    `${DOMAIN.MOBILE}.${FEATURE.LOGIN}`,
    debugValues,
  );
  await window?.flutter_inappwebview?.callHandler?.(saveSession);
  logger.info(
    ` FlutterInAppWebView Event ${saveSession} sent`,
    `${DOMAIN.MOBILE}.${FEATURE.LOGIN}`,
    debugValues,
  );
};
